(function () {
  function boot() {
    document.querySelectorAll('[data-guided-shop-section]').forEach(initGuidedShop);
  }

  function initGuidedShop(root) {
    if (root.dataset.guidedShopReady === 'true') return;
    root.dataset.guidedShopReady = 'true';

    var defaultI18n = {
      allCatalog: 'Tutto il catalogo',
      boy: 'Bambino',
      catalogLoadError: 'Non è stato possibile caricare tutte le pagine del catalogo. I risultati potrebbero essere limitati ai prodotti già caricati.',
      city: 'Città',
      female: 'Donna',
      girl: 'Bambina',
      loadingCatalog: 'Caricamento catalogo...',
      loadingCatalogLong: 'Sto caricando tutto il catalogo...',
      male: 'Uomo',
      productCountOne: '1 prodotto',
      productCountOther: '__COUNT__ prodotti',
      productCountZero: '0 prodotti',
      seeResults: 'Vedi risultati',
      showLess: 'Mostra meno',
      showMore: 'Mostra altri',
      sport: 'Sport'
    };
    var i18n = readI18n();
    var state = { gender: '', context: '', types: [], brands: [], resultsVisible: false };
    var productCache = [];
    var typeLabelByKey = {};
    var brandLabelByKey = {};
    var catalogLoading = false;
    var catalogLoadError = false;
    var loadPromise = null;

    var totalPages = parseInt(root.dataset.totalPages || '1', 10);
    var currentPage = parseInt(root.dataset.currentPage || '1', 10);
    var loadedPages = {};
    loadedPages[currentPage] = true;

    var cityCollections = splitCsv(root.dataset.cityCollections);
    var sportCollections = splitCsv(root.dataset.sportCollections);
    var typeAssetPattern = root.dataset.typeAssetPattern || '';

    var productGrid = root.querySelector('.js-product-grid');
    var typeStep = root.querySelector('.js-type-step');
    var typeGrid = root.querySelector('.js-type-grid');
    var brandStep = root.querySelector('.js-brand-step');
    var brandGrid = root.querySelector('.js-brand-grid');
    var seeResultsBtn = root.querySelector('.js-see-results');
    var seeResultsLabel = root.querySelector('.js-see-results-label');
    var previewCountEl = root.querySelector('.js-preview-count');
    var resetBtn = root.querySelector('.js-reset-filters');
    var resultsSection = root.querySelector('.js-results-section');
    var resultsCountEl = root.querySelector('.js-results-count');
    var resultsSummaryEl = root.querySelector('.js-results-summary');
    var emptyResultsEl = root.querySelector('.js-empty-results');
    var statusEl = root.querySelector('.js-catalog-status');
    var typeToggleMobile = root.querySelector('.js-type-toggle-mobile');
    var typeToggleDesktop = root.querySelector('.js-type-toggle-desktop');
    var mobileTypeLimit = 4;
    var desktopTypeLimit = 6;

    function readI18n() {
      var script = root.querySelector('.js-guided-shop-i18n');

      if (!script) return defaultI18n;

      try {
        return Object.assign({}, defaultI18n, JSON.parse(script.textContent || '{}'));
      } catch (error) {
        return defaultI18n;
      }
    }

    function translate(key) {
      return i18n[key] || defaultI18n[key] || key;
    }

    function interpolate(template, values) {
      return String(template || '').replace(/__COUNT__/g, values && values.count != null ? values.count : '');
    }

    function splitCsv(value) {
      return String(value || '').split(',').map(normalizeKey).filter(Boolean);
    }

    function normalizeKey(value) {
      return String(value || '')
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ß/g, 'ss')
        .replace(/æ/g, 'ae')
        .replace(/œ/g, 'oe')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function parseDataValues(raw) {
      if (!raw || raw === 'null' || raw === '[]') return [];

      var parsed;
      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        parsed = raw;
      }

      if (Array.isArray(parsed)) {
        return parsed.map(valueFromMetafield).map(trimValue).filter(Boolean);
      }

      if (typeof parsed === 'object' && parsed !== null) {
        var objectValue = valueFromMetafield(parsed);
        return objectValue ? [String(objectValue).trim()] : [];
      }

      var stringValue = String(parsed || '').trim();
      return stringValue ? [stringValue] : [];
    }

    function valueFromMetafield(item) {
      if (item == null) return '';
      if (typeof item === 'object') return item.label || item.name || item.value || item.title || '';
      return String(item);
    }

    function trimValue(item) {
      return String(item || '').trim();
    }

    function getSelectedTypes() {
      return Array.isArray(state.types) ? state.types : [];
    }

    function setSelectedTypes(types) {
      var clean = [];
      (types || []).forEach(function (typeKey) {
        if (typeKey && clean.indexOf(typeKey) === -1) clean.push(typeKey);
      });
      state.types = clean;
    }

    function toggleSelectedType(typeKey) {
      var selected = getSelectedTypes().slice();
      var index = selected.indexOf(typeKey);
      if (index === -1) selected.push(typeKey);
      else selected.splice(index, 1);
      setSelectedTypes(selected);
    }

    function getSelectedBrands() {
      return Array.isArray(state.brands) ? state.brands : [];
    }

    function setSelectedBrands(brands) {
      var clean = [];
      (brands || []).forEach(function (brandKey) {
        if (brandKey && clean.indexOf(brandKey) === -1) clean.push(brandKey);
      });
      state.brands = clean;
    }

    function toggleSelectedBrand(brandKey) {
      var selected = getSelectedBrands().slice();
      var index = selected.indexOf(brandKey);
      if (index === -1) selected.push(brandKey);
      else selected.splice(index, 1);
      setSelectedBrands(selected);
    }

    function inferGendersFromCollections(collections) {
      var genders = [];
      if (collections.indexOf('uomo') !== -1) genders.push('uomo');
      if (collections.indexOf('donna') !== -1) genders.push('donna');
      if (collections.indexOf('bambini') !== -1) genders.push('bambino', 'bambina', 'junior-unisex');
      return genders;
    }

    function buildProductFromCard(card) {
      var collections = splitCsv(card.dataset.collections);
      var genderLabels = parseDataValues(card.getAttribute('data-genders'));
      var genderKeys = genderLabels.map(normalizeKey).filter(Boolean);
      var typeLabels = parseDataValues(card.getAttribute('data-types'));
      var fallbackType = String(card.dataset.typeFallback || '').trim();

      if (!genderKeys.length) genderKeys = inferGendersFromCollections(collections);
      if (!typeLabels.length && fallbackType) typeLabels = [fallbackType];

      return {
        el: card,
        id: card.dataset.productId,
        title: card.dataset.title || '',
        collections: collections,
        brandLabel: card.dataset.brandLabel || '',
        brandKey: card.dataset.brandKey || normalizeKey(card.dataset.brandLabel || ''),
        brandImage: card.dataset.brandImage || '',
        genderKeys: genderKeys,
        typeLabels: typeLabels,
        typeKeys: typeLabels.map(normalizeKey).filter(Boolean)
      };
    }

    function rebuildProductCache() {
      productCache = Array.prototype.slice.call(root.querySelectorAll('.js-product-card')).map(buildProductFromCard);
    }

    function hasAny(source, allowed) {
      for (var i = 0; i < allowed.length; i += 1) {
        if (source.indexOf(allowed[i]) !== -1) return true;
      }
      return false;
    }

    function matchesGender(product, gender) {
      if (!gender) return true;
      var genders = product.genderKeys || [];
      if (gender === 'uomo') return genders.indexOf('uomo') !== -1 || genders.indexOf('unisex') !== -1;
      if (gender === 'donna') return genders.indexOf('donna') !== -1 || genders.indexOf('unisex') !== -1;
      if (gender === 'bambino') return genders.indexOf('bambino') !== -1 || genders.indexOf('junior-unisex') !== -1 || genders.indexOf('junior') !== -1;
      if (gender === 'bambina') return genders.indexOf('bambina') !== -1 || genders.indexOf('junior-unisex') !== -1 || genders.indexOf('junior') !== -1;
      return true;
    }

    function matchesContext(product, context) {
      if (!context) return true;
      if (context === 'citta') return hasAny(product.collections, cityCollections);
      if (context === 'sport') return hasAny(product.collections, sportCollections);
      return true;
    }

    function matchesType(product, typeKeys) {
      var selectedTypes = Array.isArray(typeKeys) ? typeKeys : (typeKeys ? [typeKeys] : []);
      if (!selectedTypes.length) return true;

      for (var i = 0; i < selectedTypes.length; i += 1) {
        if (product.typeKeys.indexOf(selectedTypes[i]) !== -1) return true;
      }

      return false;
    }

    function matchesBrand(product, brandKeys) {
      var selectedBrands = Array.isArray(brandKeys) ? brandKeys : (brandKeys ? [brandKeys] : []);
      if (!selectedBrands.length) return true;
      return selectedBrands.indexOf(product.brandKey) !== -1;
    }

    function matchesProduct(product, options) {
      var gender = options && Object.prototype.hasOwnProperty.call(options, 'gender') ? options.gender : state.gender;
      var context = options && Object.prototype.hasOwnProperty.call(options, 'context') ? options.context : state.context;
      var types = getSelectedTypes();
      var brands = getSelectedBrands();

      if (options && Object.prototype.hasOwnProperty.call(options, 'types')) types = options.types;
      else if (options && Object.prototype.hasOwnProperty.call(options, 'type')) types = options.type ? [options.type] : [];

      if (options && Object.prototype.hasOwnProperty.call(options, 'brands')) brands = options.brands;
      else if (options && Object.prototype.hasOwnProperty.call(options, 'brand')) brands = options.brand ? [options.brand] : [];

      return matchesGender(product, gender) && matchesContext(product, context) && matchesType(product, types) && matchesBrand(product, brands);
    }

    function countProducts(options) {
      var count = 0;
      productCache.forEach(function (product) {
        if (matchesProduct(product, options || {})) count += 1;
      });
      return count;
    }

    function formatProductCount(count) {
      if (count === 0) return translate('productCountZero');
      if (count === 1) return translate('productCountOne');
      return interpolate(translate('productCountOther'), { count: count });
    }

    function makeTypeImageUrl(typeKey) {
      if (!typeAssetPattern || !typeKey) return '';
      return typeAssetPattern.replace('__KEY__', typeKey);
    }

    function imageToFallback(img, label) {
      var wrap = img.closest('.guided-type-image-wrap, .guided-brand-image-wrap');
      if (!wrap) return;
      wrap.innerHTML = '<span class="guided-type-image-fallback">' + escapeHtml(label) + '</span>';
    }

    function buildTypeOptions() {
      var typeMap = {};

      productCache.forEach(function (product) {
        product.typeKeys.forEach(function (typeKey, index) {
          if (!typeKey || typeMap[typeKey]) return;
          typeMap[typeKey] = { key: typeKey, label: product.typeLabels[index] || typeKey };
        });
      });

      var types = Object.keys(typeMap).map(function (key) { return typeMap[key]; });
      types.sort(function (a, b) { return a.label.localeCompare(b.label, 'it', { sensitivity: 'base' }); });

      typeLabelByKey = {};
      types.forEach(function (type) { typeLabelByKey[type.key] = type.label; });
      setSelectedTypes(getSelectedTypes().filter(function (typeKey) { return typeLabelByKey[typeKey]; }));

      if (types.length <= 1) {
        typeStep.hidden = true;
        typeGrid.innerHTML = '';
        typeToggleMobile.hidden = true;
        typeToggleDesktop.hidden = true;
        return;
      }

      typeStep.hidden = false;
      typeGrid.innerHTML = types.map(function (type, index) {
        return '' +
          '<button type="button" class="guided-type-option" data-type-key="' + escapeHtml(type.key) + '" data-extra-mobile="' + (index >= mobileTypeLimit) + '" data-extra-desktop="' + (index >= desktopTypeLimit) + '" aria-pressed="false">' +
            '<span class="guided-type-image-wrap"><img class="guided-type-image" src="' + escapeHtml(makeTypeImageUrl(type.key)) + '" alt="' + escapeHtml(type.label) + '" loading="lazy"></span>' +
            '<span class="guided-type-copy"><span class="guided-type-label">' + escapeHtml(type.label) + '</span><span class="guided-type-count js-type-count">' + escapeHtml(formatProductCount(0)) + '</span></span>' +
          '</button>';
      }).join('');

      typeGrid.querySelectorAll('.guided-type-image').forEach(function (img) {
        var label = img.getAttribute('alt') || '';
        img.addEventListener('error', function () { imageToFallback(img, label); });
        if (img.complete && img.naturalWidth === 0) imageToFallback(img, label);
      });

      typeGrid.querySelectorAll('[data-type-key]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.classList.contains('disabled') && !button.classList.contains('active')) return;
          toggleSelectedType(button.dataset.typeKey || '');
          updateUI();
          if (state.resultsVisible) renderResults();
        });
      });

      typeToggleMobile.hidden = types.length <= mobileTypeLimit;
      typeToggleDesktop.hidden = types.length <= desktopTypeLimit;
    }

    function buildBrandOptions() {
      if (!brandStep || !brandGrid) return;

      var brandMap = {};

      productCache.forEach(function (product) {
        if (!product.brandKey || !product.brandLabel) return;

        if (!brandMap[product.brandKey]) {
          brandMap[product.brandKey] = {
            key: product.brandKey,
            label: product.brandLabel,
            image: product.brandImage || ''
          };
        } else if (!brandMap[product.brandKey].image && product.brandImage) {
          brandMap[product.brandKey].image = product.brandImage;
        }
      });

      var brands = Object.keys(brandMap).map(function (key) { return brandMap[key]; });
      brands.sort(function (a, b) { return a.label.localeCompare(b.label, 'it', { sensitivity: 'base' }); });

      brandLabelByKey = {};
      brands.forEach(function (brand) { brandLabelByKey[brand.key] = brand.label; });
      setSelectedBrands(getSelectedBrands().filter(function (brandKey) { return brandLabelByKey[brandKey]; }));

      if (brands.length <= 1) {
        brandStep.hidden = true;
        brandGrid.innerHTML = '';
        return;
      }

      brandGrid.innerHTML = brands.map(function (brand) {
        var imageHtml = brand.image
          ? '<img class="guided-brand-image" src="' + escapeHtml(brand.image) + '" alt="' + escapeHtml(brand.label) + '" loading="lazy">'
          : '<span class="guided-type-image-fallback">' + escapeHtml(brand.label) + '</span>';

        return '' +
          '<button type="button" class="guided-brand-option" data-brand-key="' + escapeHtml(brand.key) + '" aria-pressed="false">' +
            '<span class="guided-brand-image-wrap">' + imageHtml + '</span>' +
            '<span class="guided-brand-copy"><span class="guided-brand-label">' + escapeHtml(brand.label) + '</span><span class="guided-brand-count js-brand-count">' + escapeHtml(formatProductCount(0)) + '</span></span>' +
          '</button>';
      }).join('');

      brandGrid.querySelectorAll('.guided-brand-image').forEach(function (img) {
        var label = img.getAttribute('alt') || '';
        img.addEventListener('error', function () { imageToFallback(img, label); });
        if (img.complete && img.naturalWidth === 0) imageToFallback(img, label);
      });

      brandGrid.querySelectorAll('[data-brand-key]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.classList.contains('disabled') && !button.classList.contains('active')) return;
          toggleSelectedBrand(button.dataset.brandKey || '');
          updateUI();
        });
      });

      brandStep.hidden = !state.resultsVisible;
    }

    function updateGenderButtons() {
      root.querySelectorAll('[data-gender-group]').forEach(function (button) {
        var gender = button.dataset.genderGroup;
        var count = countProducts({ gender: gender, context: state.context, types: getSelectedTypes() });
        var isActive = state.gender === gender;
        var isDisabled = count === 0 && !isActive;

        button.classList.toggle('active', isActive);
        button.classList.toggle('disabled', isDisabled);
        button.disabled = isDisabled;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.querySelector('.js-gender-count').textContent = count;
      });
    }

    function updateContextButtons() {
      root.querySelectorAll('[data-context-group]').forEach(function (button) {
        var context = button.dataset.contextGroup;
        var count = countProducts({ gender: state.gender, context: context, types: getSelectedTypes() });
        var isActive = state.context === context;
        var isDisabled = count === 0 && !isActive;

        button.classList.toggle('active', isActive);
        button.classList.toggle('disabled', isDisabled);
        button.disabled = isDisabled;
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.querySelector('.js-context-count').textContent = formatProductCount(count);
      });
    }

    function updateTypeButtons() {
      setSelectedTypes(getSelectedTypes().filter(function (typeKey) {
        return countProducts({ gender: state.gender, context: state.context, types: [typeKey] }) > 0;
      }));

      var visibleTypeCount = 0;
      root.querySelectorAll('[data-type-key]').forEach(function (button) {
        var typeKey = button.dataset.typeKey;
        var count = countProducts({ gender: state.gender, context: state.context, types: [typeKey] });
        var isActive = getSelectedTypes().indexOf(typeKey) !== -1;
        var shouldHide = count === 0 && !isActive;

        button.hidden = shouldHide;
        button.disabled = shouldHide;

        if (!shouldHide) {
          visibleTypeCount += 1;
          button.dataset.extraMobile = visibleTypeCount > mobileTypeLimit ? 'true' : 'false';
          button.dataset.extraDesktop = visibleTypeCount > desktopTypeLimit ? 'true' : 'false';
        }

        button.classList.toggle('active', isActive);
        button.classList.toggle('disabled', shouldHide);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.querySelector('.js-type-count').textContent = formatProductCount(count);
      });

      typeToggleMobile.hidden = root.classList.contains('is-results-mode') || visibleTypeCount <= mobileTypeLimit;
      typeToggleDesktop.hidden = root.classList.contains('is-results-mode') || visibleTypeCount <= desktopTypeLimit;
    }

    function updateBrandButtons() {
      if (!brandStep || !brandGrid) return;

      setSelectedBrands(getSelectedBrands().filter(function (brandKey) {
        return countProducts({
          gender: state.gender,
          context: state.context,
          types: getSelectedTypes(),
          brands: [brandKey]
        }) > 0;
      }));

      var visibleBrandCount = 0;

      brandGrid.querySelectorAll('[data-brand-key]').forEach(function (button) {
        var brandKey = button.dataset.brandKey;
        var count = countProducts({
          gender: state.gender,
          context: state.context,
          types: getSelectedTypes(),
          brands: [brandKey]
        });
        var isActive = getSelectedBrands().indexOf(brandKey) !== -1;
        var shouldHide = count === 0 && !isActive;

        button.hidden = shouldHide;
        button.disabled = shouldHide;

        if (!shouldHide) visibleBrandCount += 1;

        button.classList.toggle('active', isActive);
        button.classList.toggle('disabled', shouldHide);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        var countEl = button.querySelector('.js-brand-count');
        if (countEl) countEl.textContent = formatProductCount(count);
      });

      brandStep.hidden = !state.resultsVisible || visibleBrandCount <= 1;
    }

    function buildSummary() {
      var parts = [];

      if (state.gender === 'uomo') parts.push(translate('male'));
      if (state.gender === 'donna') parts.push(translate('female'));
      if (state.gender === 'bambino') parts.push(translate('boy'));
      if (state.gender === 'bambina') parts.push(translate('girl'));
      if (state.context === 'citta') parts.push(translate('city'));
      if (state.context === 'sport') parts.push(translate('sport'));
      getSelectedTypes().forEach(function (typeKey) { parts.push(typeLabelByKey[typeKey] || typeKey); });
      getSelectedBrands().forEach(function (brandKey) { parts.push(brandLabelByKey[brandKey] || brandKey); });

      return parts.length ? parts.join(' · ') : translate('allCatalog');
    }

    function updateSeeResultsButton() {
      var count = countProducts();
      if (catalogLoading) {
        seeResultsBtn.disabled = true;
        seeResultsLabel.textContent = translate('loadingCatalog');
        previewCountEl.textContent = '';
        return;
      }
      seeResultsBtn.disabled = false;
      seeResultsLabel.textContent = translate('seeResults');
      previewCountEl.textContent = '(' + count + ')';
    }

    function updateStatus() {
      if (!statusEl) return;
      if (catalogLoading) {
        statusEl.hidden = false;
        statusEl.textContent = translate('loadingCatalogLong');
      } else if (catalogLoadError) {
        statusEl.hidden = false;
        statusEl.textContent = translate('catalogLoadError');
      } else {
        statusEl.hidden = true;
        statusEl.textContent = '';
      }
    }

    function updateUI() {
      updateGenderButtons();
      updateContextButtons();
      updateTypeButtons();
      updateBrandButtons();
      updateSeeResultsButton();
      updateStatus();
      if (state.resultsVisible) renderResults();
    }

    function renderResults() {
      var visibleCount = 0;
      state.resultsVisible = true;
      root.classList.add('is-results-mode');
      root.dataset.typeExpandedMobile = 'true';
      root.dataset.typeExpandedDesktop = 'true';

      productCache.forEach(function (product) {
        var isVisible = matchesProduct(product);
        product.el.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      resultsSection.hidden = false;
      emptyResultsEl.hidden = visibleCount !== 0;
      resultsCountEl.textContent = formatProductCount(visibleCount);
      resultsSummaryEl.textContent = buildSummary();
      updateTypeButtons();
      updateBrandButtons();
    }

    function hideResults() {
      state.resultsVisible = false;
      root.classList.remove('is-results-mode');
      resultsSection.hidden = true;
      productCache.forEach(function (product) { product.el.hidden = true; });
    }

    function resetFilters() {
      state.gender = '';
      state.context = '';
      setSelectedTypes([]);
      setSelectedBrands([]);
      root.dataset.typeExpandedMobile = 'true';
      root.dataset.typeExpandedDesktop = 'true';
      setToggleLabel(typeToggleMobile, '.js-type-toggle-mobile-label', true);
      setToggleLabel(typeToggleDesktop, '.js-type-toggle-desktop-label', true);
      hideResults();
      updateUI();
    }

    function setToggleLabel(toggle, selector, expanded) {
      if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = root.querySelector(selector);
      if (label) label.textContent = expanded ? translate('showLess') : translate('showMore');
    }

    function dedupeProductCards() {
      var seen = {};
      root.querySelectorAll('.js-product-card').forEach(function (card) {
        var id = card.dataset.productId;
        if (!id) return;
        if (seen[id]) card.remove();
        else seen[id] = true;
      });
    }

    function setCatalogLoading(value) {
      catalogLoading = value;
      root.classList.toggle('is-loading-catalog', value);
      root.classList.toggle('is-catalog-loading', value);
      root.setAttribute('aria-busy', value ? 'true' : 'false');
      updateStatus();
      updateSeeResultsButton();
    }

    function fetchPage(pageNumber) {
      var url = new URL(window.location.href);
      url.searchParams.set('page', pageNumber);

      return fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Page fetch failed: ' + pageNumber);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fetchedRoot = doc.querySelector('[data-guided-shop-id="' + root.dataset.guidedShopId + '"]');
          if (!fetchedRoot) return;

          fetchedRoot.querySelectorAll('.js-product-card').forEach(function (card) {
            productGrid.appendChild(card);
          });
          loadedPages[pageNumber] = true;
        });
    }

    function loadAllProductPages() {
      if (loadPromise) return loadPromise;

      var pagesToLoad = [];
      for (var page = 1; page <= totalPages; page += 1) {
        if (!loadedPages[page]) pagesToLoad.push(page);
      }

      if (!pagesToLoad.length) {
        loadPromise = Promise.resolve();
        return loadPromise;
      }

      setCatalogLoading(true);
      loadPromise = Promise.all(pagesToLoad.map(fetchPage))
        .catch(function () { catalogLoadError = true; })
        .then(function () {
          dedupeProductCards();
          rebuildProductCache();
          buildTypeOptions();
          buildBrandOptions();
          updateUI();
        })
        .finally(function () {
          setCatalogLoading(false);
          updateUI();
        });

      return loadPromise;
    }

    root.querySelectorAll('[data-gender-group]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var gender = button.dataset.genderGroup;
        state.gender = state.gender === gender ? '' : gender;
        updateUI();
      });
    });

    root.querySelectorAll('[data-context-group]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var context = button.dataset.contextGroup;
        state.context = state.context === context ? '' : context;
        updateUI();
      });
    });

    if (typeToggleMobile) {
      typeToggleMobile.addEventListener('click', function () {
        var expanded = root.dataset.typeExpandedMobile === 'true';
        root.dataset.typeExpandedMobile = expanded ? 'false' : 'true';
        setToggleLabel(typeToggleMobile, '.js-type-toggle-mobile-label', !expanded);
      });
    }

    if (typeToggleDesktop) {
      typeToggleDesktop.addEventListener('click', function () {
        var expanded = root.dataset.typeExpandedDesktop === 'true';
        root.dataset.typeExpandedDesktop = expanded ? 'false' : 'true';
        setToggleLabel(typeToggleDesktop, '.js-type-toggle-desktop-label', !expanded);
      });
    }

    if (seeResultsBtn) {
      seeResultsBtn.addEventListener('click', function () {
        if (catalogLoading) return;
        renderResults();
        updateUI();
        resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (resetBtn) resetBtn.addEventListener('click', resetFilters);

    rebuildProductCache();
    buildTypeOptions();
    buildBrandOptions();
    updateUI();
    if (totalPages > 1) loadAllProductPages();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
